import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export const departmentsQueryOptions = queryOptions({
  queryKey: ['departments'] as const,
  staleTime: 5 * 60 * 1000,
  queryFn: async () => {
    const res = await api.api.departments.$get();
    if (!res.ok) throw new Error(i18n.t('errors.unexpected'));
    return res.json();
  }
});
